import ContractsTable from "./ContractsTable";

export default function MyContracts() {
  return <ContractsTable />;
}
